export enum PdfExtractionStatus {
    IN_PROGRESS = 'IN_PROGRESS',
    FINISHED = 'FINISHED',
    ERROR = 'ERROR',
}
